import { wordService } from "../services/wordService";

export const applySubtitle = () => wordService.applySemanticTag({ type: "subtitle", styleBuiltIn: "Subtitle" });
